onComplete(function () {
	// Header scroll
	var pageScroll = 100;

	$(window).scroll(function () {
		var scroll = getCurrentScroll();
		if (scroll >= pageScroll) {
			$(".nav-header").addClass("scroll");
			$(".alert").addClass("scroll");
			$(".btn-top").addClass("show");
		} else {
			$(".nav-header").removeClass("scroll");
			$(".alert").removeClass("scroll");
			$(".btn-top").removeClass("show");
		}
	});

	function getCurrentScroll() {
		return window.pageYOffset || document.documentElement.scrollTop;
	}

	// Mobile Menu
	$(".hamburger").on("click", function () {
		$(this).find(".hambergerIcon").toggleClass("navbar--open");
		$(".navbar-mobile").toggleClass("navbar--open");
		$(".nav-header").toggleClass("navbar--open");
		$("body").toggleClass("fixed");
		return false;
	});

	$(".navbar-mobile a").on("click", function () {
		// Only trigger if the menu is actually open
		if ($(".navbar-mobile").hasClass("navbar--open")) {
			$(".hamburger").click();
		}
	});

	// Punt toevoegen titels
	function addSpanAfterHeadings() {
		const headings = document.querySelectorAll("h1, h2");
		headings.forEach((heading) => {
			const text = heading.innerText.trim();

			// Skip adding the dot if the text ends with '?' or '!'
			if (!text.endsWith("?") && !text.endsWith("!")) {
				heading.insertAdjacentHTML("beforeend", "<span class='dot'>.</span>");
			}
		});
	}
	addSpanAfterHeadings();

	// Alert Nieuwsbrief
	const alertTrigger = document.querySelector(".header .alert");
	const targetSection = document.getElementById("nieuwsbrief");

	alertTrigger.addEventListener("click", () => {
		if (targetSection) {
			targetSection.scrollIntoView({
				behavior: "smooth",
				block: "start",
			});
		}
	});

	// Makelaar section
	// const triggers = document.querySelectorAll(
	// 	'a[href="/#vraag-de-makelaar"]',
	// );
	// const section = document.getElementById("vraag-de-makelaar");
	// const closeBtn = document.querySelector(".close"); // Select your close button

	// if (section) {
	// 	// Open Logic
	// 	triggers.forEach((trigger) => {
	// 		trigger.addEventListener("click", function (e) {
	// 			e.preventDefault();
	// 			section.style.display = "block";

	// 			setTimeout(() => {
	// 				section.classList.add("is-visible");
	// 				section.scrollIntoView({
	// 					behavior: "smooth",
	// 					block: "start",
	// 				});
	// 			}, 20);

	// 			history.pushState(null, null, "#vraag-de-makelaar");
	// 		});
	// 	});

	// 	// Close Logic
	// 	if (closeBtn) {
	// 		closeBtn.addEventListener("click", function (e) {
	// 			e.preventDefault();

	// 			// 1. Remove the visibility class to trigger CSS transitions
	// 			section.classList.remove("is-visible");

	// 			// 2. Wait for the animation to finish before setting display: none
	// 			// Adjust 300ms to match your CSS transition duration
	// 			setTimeout(() => {
	// 				section.style.display = "none";
	// 			}, 300);

	// 			// 3. Clean up the URL (removes the hash without reloading)
	// 			history.pushState(null, null, window.location.pathname);
	// 		});
	// 	}
	// }

	// Makelaar section
	const section = document.getElementById("vraag-de-makelaar");
	const triggers = document.querySelectorAll('a[href="/#vraag-de-makelaar"]');
	const closeBtn = document.querySelector(".close");

	if (section) {

		const openMakelaarSection = (smooth = true) => {
			section.style.display = "block";
			setTimeout(() => {
				section.classList.add("is-visible");
				section.scrollIntoView({
					behavior: smooth ? "smooth" : "auto",
					block: "start",
				});
			}, 20);
		};

		if (window.location.hash === "#vraag-de-makelaar") {
			openMakelaarSection(false);
		}

		triggers.forEach((trigger) => {
			trigger.addEventListener("click", function (e) {
				e.preventDefault();
				openMakelaarSection(true);
				history.pushState(null, null, "#vraag-de-makelaar");
			});
		});

		if (closeBtn) {
			closeBtn.addEventListener("click", function (e) {
				e.preventDefault();
				section.classList.remove("is-visible");
				setTimeout(() => {
					section.style.display = "none";
				}, 300);
				history.pushState(null, null, window.location.pathname);
			});
		}

		window.addEventListener('hashchange', () => {
			if (window.location.hash === "#vraag-de-makelaar") {
				openMakelaarSection(true);
			} else {
				section.classList.remove("is-visible");
				setTimeout(() => { section.style.display = "none"; }, 300);
			}
		});
	}
});
